jQuery(document).ready(function () {
  jQuery("ul.children-nav > li").addClass("topLevel");
  jQuery("li.cat-item.topLevel ul").parent().addClass("cat-item-has-children");

  jQuery("ul.children-nav > li > ul > li").addClass("secondLevel");
  jQuery("ul.children-nav > li > ul > li > ul > li").addClass("thirdLevel");

  jQuery("<span class='btb bt-plus bt-1x'></span>").insertAfter(
    "li.page_item_has_children > a"
  );

  jQuery("li > span.btb").click(function () {
    jQuery(this).next("ul.children").slideToggle().toggleClass("show");
    jQuery(this).toggleClass("bt-minus");
  });

  jQuery("li").each(function () {
    if (
      jQuery(this).hasClass("current_page_item") ||
      jQuery(this).hasClass("current_page_ancestor")
    ) {
      jQuery(this).children("span.btb").addClass("bt-minus");
      jQuery(this).children("ul.children").addClass("show").show();
    }
  });

  jQuery(".sidebar-title").click(function () {
    jQuery(".sidebar-menu").slideToggle().toggleClass("showOnMobile");
    jQuery(this).toggleClass("lessMargin");
  });
});
